// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Date from "../Data.Date/index.js";
import * as Data_Date_Component from "../Data.Date.Component/index.js";
import * as Data_DateTime from "../Data.DateTime/index.js";
import * as Data_Enum from "../Data.Enum/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Number_Format from "../Data.Number.Format/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Time from "../Data.Time/index.js";
import * as Data_Time_Component from "../Data.Time.Component/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Elements_Keyed from "../Halogen.HTML.Elements.Keyed/index.js";
import * as Halogen_HTML_Events from "../Halogen.HTML.Events/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Halogen_Styled from "../Halogen.Styled/index.js";
import * as Halogen_Styled_DSL from "../Halogen.Styled.DSL/index.js";
import * as Visonum_API_SpeedMaster from "../Visonum.API.SpeedMaster/index.js";
import * as Visonum_BulkPingApp_AppHTML from "../Visonum.BulkPingApp.AppHTML/index.js";
import * as Visonum_BulkPingApp_Components_App_Types from "../Visonum.BulkPingApp.Components.App.Types/index.js";
import * as Visonum_BulkPingApp_Imgs from "../Visonum.BulkPingApp.Imgs/index.js";
import * as Visonum_BulkPingApp_Util from "../Visonum.BulkPingApp.Util/index.js";
var inline = /* #__PURE__ */ Halogen_Styled_DSL.inline();
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var fromEnum = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumHour);
var fromEnum1 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumMinute);
var fromEnum2 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Time_Component.boundedEnumSecond);
var fromEnum3 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumYear);
var fromEnum4 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumMonth);
var fromEnum5 = /* #__PURE__ */ Data_Enum.fromEnum(Data_Date_Component.boundedEnumDay);
var select = /* #__PURE__ */ Halogen_Styled_DSL.select();
var select_ = /* #__PURE__ */ Halogen_Styled_DSL.select_();
var fold = /* #__PURE__ */ Data_Foldable.fold(Data_Foldable.foldableArray)(Halogen_Styled.monoidUpdateOpts);
var step = /* #__PURE__ */ Halogen_Styled_DSL.step();
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Halogen_Styled.monoidUpdateOpts);
var compare = /* #__PURE__ */ Data_Ord.compare(Data_DateTime.ordDateTime);
var toUnfoldable = /* #__PURE__ */ Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var viewProgressBar = function (part) {
    return function (whole) {
        var percent = 100.0 * (Data_Int.toNumber(part) / Data_Int.toNumber(whole));
        var percentStr = Data_Number_Format.toStringWith(Data_Number_Format.fixed(1))(percent);
        var elRoot = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("ProgressBar")([ inline({
            display: "flex",
            width: "100%",
            height: "3px",
            backgroundColor: "rgba(255, 255, 255, 0.5);",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            borderRadius: "2px",
            overflow: "hidden",
            opacity: (function () {
                var $27 = part === whole;
                if ($27) {
                    return "0.0";
                };
                return "1";
            })()
        }) ]);
        var elBar = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Bar")([ inline({
            height: "100%",
            position: "absolute",
            backgroundColor: "black",
            left: "0",
            width: percentStr + "%",
            transition: "width 1000ms linear",
            opacity: "0.4"
        }) ]);
        return elRoot([  ])([ elBar([  ])([  ]) ]);
    };
};
var printTime = function (time) {
    return Visonum_BulkPingApp_Util.padWith(2)(show(fromEnum(Data_Time.hour(time)))) + (":" + (Visonum_BulkPingApp_Util.padWith(2)(show(fromEnum1(Data_Time.minute(time)))) + (":" + Visonum_BulkPingApp_Util.padWith(2)(show(fromEnum2(Data_Time.second(time)))))));
};
var printDate = function (date) {
    return Visonum_BulkPingApp_Util.padWith(4)(show(fromEnum3(Data_Date.year(date)))) + ("/" + (Visonum_BulkPingApp_Util.padWith(2)(show(fromEnum4(Data_Date.month(date)))) + ("/" + Visonum_BulkPingApp_Util.padWith(2)(show(fromEnum5(Data_Date.day(date)))))));
};
var viewJob = function (state) {
    return function (v) {
        var isSelected = (function () {
            if (state.details instanceof Data_Maybe.Just) {
                return state.details.value0.jobId === v.value0;
            };
            return false;
        })();
        var isRunning = (function () {
            if (v.value1.status instanceof Visonum_API_SpeedMaster.Running) {
                return true;
            };
            return false;
        })();
        var elUUID = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("UUID")([ inline({
            gridArea: "UUID",
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            fontFamily: "Monospace",
            fontSize: "10px",
            fontFeatureSettings: "\"tnum\""
        }) ]);
        var elTime = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Time")([ inline({
            gridArea: "Time",
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            fontFeatureSettings: "\"tnum\""
        }) ]);
        var elStatusIcon = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("StatusIcon")([ inline({
            gridArea: "StatusIcon",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }) ]);
        var elRoot = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Job")([ Halogen_Styled_DSL.scopedSheet(select("")({
            width: "100%",
            height: "50px",
            outline: (function () {
                if (isSelected) {
                    return "2px solid #65687d";
                };
                return "1px solid #ACABAC";
            })(),
            borderRadius: "8px",
            backgroundColor: (function () {
                if (v.value1.status instanceof Visonum_API_SpeedMaster.Failed) {
                    return "#f0e0e0" + (function () {
                        if (isSelected) {
                            return "FF";
                        };
                        return "88";
                    })();
                };
                if (v.value1.status instanceof Visonum_API_SpeedMaster.Finished) {
                    return "#e0f0e0" + (function () {
                        if (isSelected) {
                            return "FF";
                        };
                        return "88";
                    })();
                };
                if (v.value1.status instanceof Visonum_API_SpeedMaster.Running) {
                    return "#d0d7ff" + (function () {
                        if (isSelected) {
                            return "FF";
                        };
                        return "88";
                    })();
                };
                if (v.value1.status instanceof Visonum_API_SpeedMaster.Cancelled) {
                    return "#f0f0e0" + (function () {
                        if (isSelected) {
                            return "FF";
                        };
                        return "88";
                    })();
                };
                if (v.value1.status instanceof Visonum_API_SpeedMaster.Pending) {
                    return "white";
                };
                throw new Error("Failed pattern match at Visonum.BulkPingApp.MainPanel (line 91, column 30 - line 96, column 33): " + [ v.value1.status.constructor.name ]);
            })(),
            transition: "background-color 0.1s",
            fontSize: "12px",
            fontFamily: "Arial",
            display: "flex",
            flexDirection: "row"
        })) ]);
        var elProgressBar = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("ProgressBar")([ inline({
            gridArea: "ProgressBar",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }) ]);
        var elProgress = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Progress")([ inline({
            gridArea: "Progress",
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            fontSize: "10px",
            fontFeatureSettings: "\"tnum\""
        }) ]);
        var elMain = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Main")([ Halogen_Styled_DSL.scopedSheet(select_({
            display: "grid",
            width: "100%",
            height: "100%",
            borderRadius: "8px",
            paddingRight: "10px",
            gridTemplateColumns: "40px 80px 80px 90px auto",
            gridTemplateRows: "1fr 1fr 1fr",
            gridTemplateAreas: Data_String_Common.joinWith(" ")([ "\"StatusIcon Empty       Empty       Empty       Empty      \"", "\"StatusIcon Date        Time        Progress    UUID       \"", "\"StatusIcon ProgressBar ProgressBar ProgressBar ProgressBar\"" ]),
            fontSize: "12px",
            fontWeight: (function () {
                if (isSelected) {
                    return "bold";
                };
                return "normal";
            })(),
            fontFamily: "Arial",
            cursor: "pointer"
        })), Halogen_Styled_DSL.scopedSheet(select(":hover")({
            fontWeight: "bold"
        })) ]);
        var elImg = Visonum_BulkPingApp_AppHTML.styleLeaf(Halogen_HTML_Elements.img)("Img")([ inline({
            width: "20px",
            height: "20px"
        }), (function () {
            if (v.value1.status instanceof Visonum_API_SpeedMaster.Running) {
                return fold([ Halogen_Styled_DSL.scopedSheet(Halogen_Styled_DSL.animation([ step("from")({
                    transform: "rotate(0deg)"
                }), step("to")({
                    transform: "rotate(359deg)"
                }) ])), Halogen_Styled_DSL.scopedSheet(select_({
                    animation: "3s linear infinite"
                })) ]);
            };
            return mempty;
        })() ]);
        var elEmpty = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Empty")([ inline({
            gridArea: "Empty"
        }) ]);
        var elDate = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Date")([ inline({
            gridArea: "Date",
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            fontFeatureSettings: "\"tnum\""
        }) ]);
        var elCancel = Visonum_BulkPingApp_AppHTML.styleLeaf(Halogen_HTML_Elements.img)("Cancel")([ inline({
            cursor: "pointer",
            width: "20px",
            height: "20px"
        }) ]);
        var elActions = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Cancel")([ inline({
            display: "flex",
            justifyContent: "center",
            alignItems: "start",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            marginLeft: "5px",
            padding: "5px"
        }) ]);
        return elRoot([ Halogen_HTML_Events.onClick(Data_Function["const"](new Visonum_BulkPingApp_Components_App_Types.ShowDetails(v.value0))) ])([ elMain([  ])([ elEmpty([  ])([  ]), elStatusIcon([  ])([ elImg((function () {
            if (v.value1.status instanceof Visonum_API_SpeedMaster.Running) {
                return [ Halogen_HTML_Properties.src(Visonum_BulkPingApp_Imgs.imgWheel) ];
            };
            if (v.value1.status instanceof Visonum_API_SpeedMaster.Finished) {
                return [ Halogen_HTML_Properties.src(Visonum_BulkPingApp_Imgs.imgSuccess) ];
            };
            if (v.value1.status instanceof Visonum_API_SpeedMaster.Failed) {
                return [ Halogen_HTML_Properties.src(Visonum_BulkPingApp_Imgs.imgExclamation) ];
            };
            if (v.value1.status instanceof Visonum_API_SpeedMaster.Cancelled) {
                return [ Halogen_HTML_Properties.src(Visonum_BulkPingApp_Imgs.imgCancelled) ];
            };
            if (v.value1.status instanceof Visonum_API_SpeedMaster.Pending) {
                return [  ];
            };
            throw new Error("Failed pattern match at Visonum.BulkPingApp.MainPanel (line 257, column 19 - line 267, column 25): " + [ v.value1.status.constructor.name ]);
        })()) ]), elDate([  ])([ Halogen_Styled.text(printDate(Data_DateTime.date(v.value1.startedAt))) ]), elTime([  ])([ Halogen_Styled.text(printTime(Data_DateTime.time(v.value1.startedAt))) ]), elUUID([  ])([ Halogen_Styled.text(v.value0) ]), elProgress([  ])([ Halogen_Styled.text(show(v.value1.processedIpCount) + ("/" + show(v.value1.initialIpCount))) ]), elProgressBar([  ])([ viewProgressBar(v.value1.processedIpCount)(v.value1.initialIpCount) ]) ]), (function () {
            var $43 = isSelected && isRunning;
            if ($43) {
                return elActions([ Halogen_HTML_Events.onClick(Data_Function["const"](new Visonum_BulkPingApp_Components_App_Types.CancelJob(v.value0))) ])([ elCancel([ Halogen_HTML_Properties.src(Visonum_BulkPingApp_Imgs.imgCross) ]) ]);
            };
            return Halogen_Styled.text("");
        })() ]);
    };
};
var view = function (state) {
    var sortedJobs = Data_Array.sortBy(function (v) {
        return function (v2) {
            return compare(v2.value1.startedAt)(v.value1.startedAt);
        };
    })(toUnfoldable(state.bulkPingStatus.jobs));
    var elRoot = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("MainPanel")([ inline({
        display: "flex",
        flexDirection: "row",
        width: "100%",
        padding: "15px",
        justifyContent: "space-between",
        fontFamily: "Arial",
        fontSize: "12px"
    }) ]);
    var elJobs = Visonum_BulkPingApp_AppHTML.styleNodeKeyed(Halogen_HTML_Elements_Keyed.div)("Jobs")([ inline({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        justifyContent: "space-between",
        gap: "16px"
    }) ]);
    return elRoot([  ])([ (function () {
        var $52 = Data_Array.length(sortedJobs) === 0;
        if ($52) {
            return Halogen_Styled.text("No Bulk Ping jobs available");
        };
        return elJobs([  ])(map(function (v) {
            return new Data_Tuple.Tuple(v.value0, viewJob(state)(v));
        })(sortedJobs));
    })() ]);
};
export {
    view
};
//# sourceMappingURL=index.js.map
